import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../../../models/utilities/document-request";
import { API_METHODS } from "../../../../models/utilities/type-models";
import { ApiEndpoints } from "../../../../utils/app-constants";

export class DocumentPickListReportExport implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(orderId: string) {
        this.url = ApiEndpoints.ORDERING_PICK_LIST_EXPORT.formattify(orderId);
        this.filename = `${orderId}_Picklist`;
    }

}
